module.exports = __webpack_public_path__ + "img/icon_2.5b75c4e8.png";